import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoDocumentosPlantillasListaItemComponent {
  data

  constructor () {

  }

  $onInit () {
    this.nivel = this.nivel.split('')
  }

  mostrar () {
    this.abrir = !this.abrir
    if (Array.isArray(this.nivel)) {
      this.nivel = this.nivel.join().split(",").join("");

    }
  }
}

module.component('fanProyectoDocumentosPlantillasListaItemCarpeta', {
  controller: FanProyectoDocumentosPlantillasListaItemComponent,
  template: template,
  bindings: {
    data: '<',
    nivel: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/documentos/plantillas/lista/item-carpeta/component.js